import React,{useState,useEffect,useCallback}from'react';
import{Share2,Copy,Trash2}from'lucide-react';
import{theme}from'./theme';
import{apiCall,timeAgo}from'./api';
import{Card,FileTypeIcon,EmptyState,ErrorBanner,IconBtn}from'./components';
export default function SharedScreen({token}){
  const[shares,setShares]=useState([]);
  const[loading,setLoading]=useState(true);
  const[error,setError]=useState('');
  const load=useCallback(async()=>{setLoading(true);setError('');try{const d=await apiCall('/shares',token);setShares(Array.isArray(d)?d:[]);}catch(e){setError(e.message);}finally{setLoading(false);};},[token]);
  useEffect(()=>{load();},[load]);
  const handleRevoke=async(s)=>{try{await apiCall(`/shares/${s.id}`,token,{method:'DELETE'});load();}catch(e){setError(e.message);}};
  const copyLink=(s)=>{const t=s.shareToken||s.token;navigator.clipboard.writeText(`${window.location.origin}/shared/${t}`);};
  return<div style={{padding:24}}>
    <div style={{marginBottom:16}}>
      <h2 style={{color:theme.text,fontSize:17,fontWeight:500,margin:0}}>Shared</h2>
      <p style={{color:theme.textFaint,fontSize:12.5,marginTop:4}}>Files you've shared with a link</p>
    </div>
    <ErrorBanner message={error}/>
    {loading?<p style={{color:theme.textFaint,fontSize:12.5}}>Loading…</p>:shares.length===0?<Card><EmptyState icon={Share2} label="You haven't shared any files yet"/></Card>:
      <div style={{border:`1px solid ${theme.border}`,borderRadius:theme.radius,overflow:'hidden'}}>
        <div style={{display:'flex',padding:'9px 16px',background:theme.bgCard,fontSize:10.5,color:theme.textFaint,textTransform:'uppercase',letterSpacing:'0.05em',borderBottom:`1px solid ${theme.border}`}}>
          <div style={{width:30,marginRight:12}}/><div style={{flex:1}}>File</div><div style={{width:100}}>Downloads</div><div style={{width:110}}>Shared</div><div style={{width:80}}/>
        </div>
        {shares.map(s=><div key={s.id} style={{display:'flex',alignItems:'center',padding:'10px 16px',borderBottom:`1px solid ${theme.border}`,fontSize:13}}>
          <FileTypeIcon fileName={s.cloudFile?.fileName||s.fileName} isFolder={false} size={30}/>
          <div style={{flex:1,color:theme.text,marginLeft:12}}>{s.cloudFile?.fileName||s.fileName||'File'}</div>
          <div style={{width:100,color:theme.textFaint,fontSize:12.5}}>{s.downloadCount??0}</div>
          <div style={{width:110,color:theme.textFaint,fontSize:12.5}}>{timeAgo(s.createdAt)}</div>
          <div style={{display:'flex',gap:2,width:80,justifyContent:'flex-end'}}>
            <IconBtn icon={Copy} title="Copy link" onClick={()=>copyLink(s)}/>
            <IconBtn icon={Trash2} title="Revoke" onClick={()=>handleRevoke(s)}/>
          </div>
        </div>)}
      </div>}
  </div>;
}
